<div class="flex items-center gap-4 group cursor-text min-w-0 w-full" (click)="focusInput()">
  @if (!isEditing()) {
    <!-- Display mode - only as wide as needed -->
    <span class="truncate border-0 border-b-2 border-white">
      {{ value() || placeholder() }}
    </span>
  } @else {
    <!-- Edit mode - fills available space -->
    <input
      #inputElement
      class="bg-transparent border-0 border-b-2 border-dashed border-secondary outline-none p-0 flex-1 min-w-0 transition-colors duration-200 placeholder:text-gray-400 [font:inherit] [color:inherit] [letter-spacing:inherit] [line-height:inherit] [text-align:inherit]"
      type="text"
      [ngModel]="value()"
      [placeholder]="placeholder()"
      [disabled]="disabled()"
      (ngModelChange)="onValueChange($event)"
      (change)="onBlur()"
      (blur)="onBlur()"
      (keydown.enter)="onBlur()"
      (keydown.escape)="onEscape()" />
  }

  <!-- Edit icon -->
  <ui-icon class="cursor-pointer text-gray-400 flex-shrink-0" icon="griddy-edit" (click)="focusInput()" />
</div>
